<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Ændr ordretypen</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content>
  <form [formGroup]="form" autocomplete="off">
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Ny opgavetype</mat-label>
        <mat-select formControlName="newOpgaveType" (selectionChange)="onOpgaveTypeChange($event.value)">
          @for (opgavetype of opgaveTyper; track opgavetype) {
            <mat-option [value]="opgavetype">{{ opgavetype }}</mat-option>
          }
        </mat-select>
        <mat-icon matSuffix class="select-arrow">keyboard_arrow_down</mat-icon>
      </mat-form-field>
    </div>
  </form>
</div>
<div>
  <p>
    Du skal være opmærksom på, om kundens opkrævning og afregning af s-partner håndteres forskelligt alt efter serviceordrens opgavetype,
    hvorfor du manuelt skal sikre dette ser korrekt ud.
  </p>
  <p>
    Du skal desuden manuelt sikre at næste eftersyn dato står korrekt samt sikre, at der ikke køres 2x eftersyn i samme periode. Dette sker
    ikke automatisk.
  </p>
</div>
<div mat-dialog-actions class="row-reverse">
  <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">Gem</button>
  <button class="modal-cancel" (click)="cancel()" mat-raised-button>Fortryd</button>
</div>
